import moment from "moment";

export class BatchPredictionMonitor {
  /**
   * Create a Batch Prediction Monitor
   * @param {string} id - monitor id
   * @param {string} name - monitor name
   * @param {boolean} isConnected - whether the monitor is connected or not
   * @param {string} period - the period in mins
   * @param {object} datasetName - used dataset name
   * @param {object} executionName - used execution name
   * @param {string[]} activeDays - active days for the execution
   * @param {object} files - files for the execution
   */
  constructor(id, name, isConnected, period, datasetName, datasetId, executionName, activeDays = [], files = {}) {
    /** @type {string} */
    this.id = id;
    /** @type {string} */
    this.name = name;
    /** @type {boolean} */
    this.isConnected = isConnected;
    /** @type {string} */
    this.period = period;
    /** @type {object} */
    this.datasetName = datasetName;
    /** @type {object} */
    this.executionName = executionName;
    /** @type {string[]} */
    this.activeDays = activeDays;
    /** @type {object} */
    this.files = files;
    /** @type {string} */
    this.datasetId = datasetId;
  }

  /**
   * Map data from api to instance of BatchPredictionMonitor
   * @returns {BatchPredictionMonitor} new instance with the mapped data
   */
  static fromApi({
    _id,
    name,
    is_paused,
    periodic_mins,
    dataset_info = {},
    training_execution_info = {},
    active_days = [],
    output_files = {},
    dataset_id = "",
  }) {
    return new BatchPredictionMonitor(
      _id,
      name,
      !is_paused,
      periodic_mins,
      dataset_info?.name ?? "",
      dataset_id,
      training_execution_info?.name ?? "",
      active_days.map((date) => moment(date).format("Y-M-D")),
      output_files
    );
  }

  /**
   * Get a copy of this object
   * @returns {BatchPredictionMonitor} the colned instance
   */
  clone() {
    return new BatchPredictionMonitor(
      this.id,
      this.name,
      this.isConnected,
      this.period,
      this.datasetName,
      this.executionName,
      [...this.activeDays]
    );
  }

  /**
   * set the active days for the monitor
   * @param {string[]} activeDays
   */
  setActiveDays(activeDays) {
    this.activeDays = [...activeDays];
  }
}
